/**
 * src/api/context.js
 *
 * Purpose: a tiny app-context registry that holds live references to the root
 * Vue instance, the Vuex store and the vue-router — the re-authored stand-in
 * for the deployed pro-ui `getVue()` accessor (the request layer called
 * `getVue().$store.dispatch(...)` / `getVue().$router.push(...)`).
 *
 * It exists to break the request<->store import cycle: `request.js` reads the
 * store/router through these getters instead of importing the store module
 * directly, and `store/index.js` (plus the app entry `main.js`) populate them.
 *
 * Reconstructed from lacak.io deployed behavior; the `getVue()` indirection is
 * a verbatim behavioural contract, internal impl re-authored.
 */

let _vue = null;
let _store = null;
let _router = null;

export function setVueInstance(vue) {
  _vue = vue;
}

export function getVueInstance() {
  return _vue;
}

export function setStore(store) {
  _store = store;
}

export function getStore() {
  // Prefer an explicitly-registered store; fall back to the root Vue's $store.
  return _store || (_vue && _vue.$store) || null;
}

export function setRouter(router) {
  _router = router;
}

export function getRouter() {
  return _router || (_vue && _vue.$router) || null;
}
